module.exports = __webpack_public_path__ + "img/SieIstSOOSchrecklich.25854d02.jpg";